import { create } from "zustand";
import { AgeCategory } from "@prisma-remote/client";
import { apiClient } from "src/services/apiClient";

interface AgeCategoryState {
  agecategories: AgeCategory[];
  fetchAgeCategories: (organisationId?: string) => Promise<void>;
}

export const useAgeCategoryStore = create<AgeCategoryState>((set) => ({
  agecategories: [],
  fetchAgeCategories: async (organisationId) => {
    const query = organisationId
      ? `?organisationId=${encodeURIComponent(organisationId)}`
      : "";
    try {
      const agecategories = await apiClient.get<AgeCategory[]>(
        `/age-categories${query}`,
        { requiresAuth: false },
      );
      set({ agecategories });
    } catch {
      set({ agecategories: [] });
    }
  },
}));
